module.exports = __webpack_public_path__ + "static/media/seem.54380c5a.png";